import React from 'react';
import {counterAction} from "../../../../store/actions/sidebarActions";
import {connect} from "react-redux";
import * as consts from "../../../../store/constants/sidebar";


class CounterNotifications extends React.Component {

  componentDidMount() {
    if (this.props.notifications.items) return;
    this.props.fetchData(process.env.REACT_APP_GATE + "notifications/count", consts.NOTIFICATIONS_COUNT);
  }

  render() {
    if(this.props.notifications.items) {
      if (this.props.notifications.items.data) {
        if(document.querySelector('#notifications-list')) return false;
        let notificationsAmount = document.createElement('span');
        notificationsAmount.setAttribute('id', 'notifications-list');
        notificationsAmount.innerHTML = this.props.notifications.items.data.count
        if(this.props.notifications.items.data.count > 0) {
          const notificationsMenu = document.querySelector('[data-menu="notifications"]');
          if(notificationsMenu) notificationsMenu.appendChild(notificationsAmount)
        }
      }
    }
    return null;
  }
}

const mapStateToProps = state => ({notifications: state.notificationsCount});

const mapDispatchToProps = dispatch => {
  return {fetchData: (url, types) => dispatch(counterAction(url, types))};
}

export default connect(mapStateToProps, mapDispatchToProps)(CounterNotifications);